// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__ZjABY","buttons":"PendingPaymentAlert_buttons__1aVrj"};